import { render, staticRenderFns } from "./NewConversation.vue?vue&type=template&id=2aa13c07&"
import script from "./NewConversation.vue?vue&type=script&lang=js&"
export * from "./NewConversation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa13c07')) {
      api.createRecord('2aa13c07', component.options)
    } else {
      api.reload('2aa13c07', component.options)
    }
    module.hot.accept("./NewConversation.vue?vue&type=template&id=2aa13c07&", function () {
      api.rerender('2aa13c07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/contact/NewConversation.vue"
export default component.exports